import React from 'react'
import styled, { css } from 'styled-components'
import ReactSlider from 'react-slider'

export const StyledSlider = styled(ReactSlider)`
  width: 100%;
  height: 8px;
  margin-top: 0.5rem;

  &.disabled {
    opacity: 0.5;
    .thumb {
      cursor: not-allowed;
    }
  }
`

export const StyledThumb = styled.div`
  height: 14px;
  line-height: 14px;
  width: 14px;
  text-align: center;
  background-color: ${({ theme }) => theme.palette.success[1]};
  color: #fff;
  border-radius: 50%;
  cursor: grab;
  box-shadow: 0px 0px 1px 1px #349248;

  &:focus-visible {
    outline: none;
  }
`

export const Thumb = (props, state) => <StyledThumb {...props} />

export const StyledTrack = styled.div`
  top: 4px;
  bottom: 0;
  height: 6px;
  background: ${({ index, theme }) =>
    index === 2 ? '#ddd' : index === 1 ? theme.palette.success[1] : '#ddd'};
  border-radius: 0.5rem;
`

export const Track = (props, state) => (
  <StyledTrack {...props} index={state.index} />
)
